module.exports = __webpack_public_path__ + "static/media/hans_germna.21aa0d16.mp3";